import { render, staticRenderFns } from "./Estates.vue?vue&type=template&id=63322e26&scoped=true&"
import script from "./Estates.vue?vue&type=script&lang=ts&"
export * from "./Estates.vue?vue&type=script&lang=ts&"
import style0 from "./Estates.vue?vue&type=style&index=0&id=63322e26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63322e26",
  null
  
)

export default component.exports